import { AppModel } from '../models';

const DEFAULT_CURRENCY = {
    code: 'EUR',
    symbol: '€',
    name: 'Euro',
};

const GetCurrencyPlugin = {
    install(Vue, options) {
        Vue.prototype.$getDefaultCurrency = function() {
            if(!AppModel.activeCampground) {
                return DEFAULT_CURRENCY;
            }
            let campgroundCurrency = DEFAULT_CURRENCY;
            AppModel.currencies.forEach((currency) => {
                if(currency.code === AppModel.activeCampground.settings.currency) {
                    campgroundCurrency = currency;
                }
            });

            return campgroundCurrency;
        };
    }
};

export default GetCurrencyPlugin;



// WEBPACK FOOTER //
// ./src/plugins/GetCurrencyPlugin.js